module.exports = __webpack_public_path__ + "img/TodaFallaDeCCTEnActivacion.0764499f.svg";